<template>
  <Day day="09.12.2025">
    <div slot="page-content">
      <h3>Urlaubsvibes</h3>
      <p>
        <img src="@/assets/day9.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day09',
  components: {
    Day
  }
}
</script>
